import React from "react";
import { Tooltip } from "@mantine/core";

export const BscTokenIcon = ({ size }) => (
  <Tooltip label="BNB Chain" arrowSize={4} withArrow>
    <div>
      <svg viewBox="0 0 24 24" width={size} height={size}>
        <circle cx="12" cy="12" r="12" fill="#F0B90B"></circle>
        <path
          d="M7.754 6.45L12 4l4.246 2.45-1.561.906L12 5.811 9.315 7.356zm8.492 3.091l-1.561-.905L12 10.181 9.315 8.636l-1.56.905v1.811l2.684 1.546v3.09l1.561.906 1.561-.906v-3.09l2.685-1.546zm0 4.902v-1.81l-1.561.905v1.81zm1.108.64l-2.685 1.545v1.811l4.246-2.45v-4.902l-1.56.905zm-1.56-7.087l1.56.905v1.811l1.561-.905v-1.81l-1.56-.906zm-5.355 9.288v1.81L12 20l1.561-.905v-1.811L12 18.189zm-2.685-2.841l1.561.905v-1.81l-1.56-.906zm2.685-6.447L12 8.901l1.561-.905L12 7.091zm-3.793.905l1.56-.905-1.56-.905-1.561.905v1.81l1.56.906zm0 3.091l-1.561-.905v4.901L9.33 18.44v-1.81l-2.685-1.546z"
          fill="#fff"
        ></path>
      </svg>
      <span className="sr-only">BSC</span>
    </div>
  </Tooltip>
);

export const EthTokenIcon = ({ size }) => (
  <Tooltip label="Ethereum" arrowSize={4} withArrow>
    <div>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#a)">
          <path
            d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z"
            fill="#627EEA"
          ></path>
          <path
            d="M12 3v6.652l5.623 2.513L12 3z"
            fill="#fff"
            fill-opacity="0.602"
          ></path>
          <path d="M12.373 3L6.75 12.165l5.623-2.512V3z" fill="#fff"></path>
          <path
            d="M12 16.764v4.52l5.627-7.784L12 16.764z"
            fill="#fff"
            fill-opacity="0.602"
          ></path>
          <path
            d="M12.373 21.284v-4.52L6.75 13.5l5.623 7.784z"
            fill="#fff"
          ></path>
          <path
            d="M12 15.526l5.623-3.265L12 9.75v5.776z"
            fill="#fff"
            fill-opacity="0.2"
          ></path>
          <path
            d="M6.75 12.261l5.623 3.265V9.75L6.75 12.261z"
            fill="#fff"
            fill-opacity="0.602"
          ></path>
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h24v24H0z"></path>
          </clipPath>
        </defs>
      </svg>
    </div>
  </Tooltip>
);

export const SolTokenIcon = ({ size }) => (
  <Tooltip label="Solana" arrowSize={4} withArrow>
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="currentColor"
        viewBox="0 0 24 24"
        class="rounded"
      >
        <rect width="24" height="24" fill="none"></rect>
        <rect width="24" height="24" fill="black"></rect>
        <path
          d="M18.9277 15.872L16.6165 18.35C16.5665 18.4039 16.506 18.4468 16.4387 18.4762C16.3714 18.5056 16.2987 18.5208 16.2252 18.5209H5.2695C5.21725 18.5209 5.16614 18.5056 5.12243 18.477C5.07872 18.4483 5.04431 18.4076 5.02341 18.3597C5.0025 18.3118 4.99602 18.2589 5.00475 18.2073C5.01348 18.1558 5.03705 18.108 5.07256 18.0696L7.38109 15.5915C7.43108 15.5377 7.49161 15.4948 7.55894 15.4654C7.62625 15.436 7.69891 15.4208 7.77237 15.4207H18.7281C18.7808 15.4196 18.8327 15.4341 18.8772 15.4625C18.9217 15.4908 18.9569 15.5316 18.9781 15.5799C18.9995 15.6281 19.006 15.6816 18.997 15.7336C18.988 15.7855 18.9639 15.8337 18.9277 15.872ZM16.6165 10.8806C16.5663 10.827 16.5058 10.7842 16.4385 10.7548C16.3712 10.7255 16.2986 10.7101 16.2252 10.7097H5.2695C5.21725 10.7098 5.16614 10.725 5.12243 10.7537C5.07872 10.7823 5.04431 10.823 5.02341 10.8709C5.0025 10.9188 4.99602 10.9718 5.00475 11.0233C5.01348 11.0748 5.03705 11.1227 5.07256 11.161L7.38109 13.6404C7.43127 13.694 7.49185 13.7367 7.55912 13.7661C7.62639 13.7955 7.69896 13.8109 7.77237 13.8112H18.7281C18.7803 13.811 18.8311 13.7955 18.8747 13.7668C18.9183 13.7381 18.9524 13.6973 18.9732 13.6494C18.9939 13.6016 19.0003 13.5488 18.9914 13.4974C18.9827 13.446 18.9592 13.3982 18.9237 13.36L16.6165 10.8806ZM5.2695 9.10027H16.2252C16.2987 9.1002 16.3714 9.08498 16.4387 9.05558C16.506 9.0262 16.5665 8.98323 16.6165 8.92941L18.9277 6.45133C18.9639 6.41305 18.988 6.3649 18.997 6.31292C19.006 6.26095 18.9995 6.20748 18.9781 6.15924C18.9569 6.111 18.9217 6.07015 18.8772 6.04183C18.8327 6.0135 18.7808 5.99897 18.7281 6.00006H7.77237C7.69891 6.00013 7.62625 6.01535 7.55894 6.04474C7.49161 6.07414 7.43108 6.11709 7.38109 6.17091L5.07256 8.64899C5.03705 8.68733 5.01348 8.73519 5.00475 8.78671C4.99602 8.83823 5.0025 8.89117 5.02341 8.93906C5.04431 8.98695 5.07872 9.02771 5.12243 9.05634C5.16614 9.08498 5.21725 9.10024 5.2695 9.10027Z"
          fill="url(#paint0_linear_4485_15574)"
        ></path>
        <defs>
          <linearGradient
            id="paint0_linear_4485_15574"
            x1="6.18248"
            y1="18.8196"
            x2="17.6704"
            y2="5.86833"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.08" stop-color="#9945FF"></stop>
            <stop offset="0.3" stop-color="#8752F3"></stop>
            <stop offset="0.5" stop-color="#5497D5"></stop>
            <stop offset="0.6" stop-color="#43B4CA"></stop>
            <stop offset="0.72" stop-color="#28E0B9"></stop>
            <stop offset="0.97" stop-color="#19FB9B"></stop>
          </linearGradient>
        </defs>
      </svg>
    </div>
  </Tooltip>
);

export const AvaxTokenIcon = ({ size }) => (
  <Tooltip label="Avalanche" arrowSize={4} withArrow>
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="currentColor"
        viewBox="0 0 24 24"
        class="rounded"
      >
        <rect width="24" height="24" fill="none"></rect>
        <rect width="24" height="24" fill="#E84142"></rect>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.37398 19.9531H4.3524C3.96377 20.0039 3.56861 19.9612 3.19983 19.8285C3.10145 19.7624 3.01944 19.6747 2.96006 19.5722C2.90068 19.4696 2.86549 19.3548 2.85718 19.2366C2.85718 19.003 2.99735 18.7226 3.30886 18.1775L10.7849 5.01648C11.0964 4.45577 11.2522 4.191 11.4547 4.08197C11.5637 4.02836 11.6836 4.00049 11.8051 4.00049C11.9266 4.00049 12.0465 4.02836 12.1556 4.08197C12.358 4.191 12.5138 4.45577 12.8409 5.01648L14.3984 7.69541C14.6498 8.07723 14.8489 8.49107 14.9902 8.92585C15.0681 9.27459 15.0681 9.63622 14.9902 9.98496C14.8489 10.4197 14.6498 10.8336 14.3984 11.2154L10.4579 18.1308C10.2604 18.5498 10.0034 18.938 9.69468 19.2833C9.43623 19.5323 9.12072 19.7141 8.77575 19.8129C8.31691 19.9224 7.84541 19.9696 7.37398 19.9531Z"
          fill="white"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.0058 19.9524H19.3357C19.7243 20.0033 20.1194 19.9605 20.4882 19.8278C20.5878 19.7593 20.6704 19.669 20.7298 19.5637C20.7892 19.4585 20.8237 19.341 20.8309 19.2204C20.8309 19.0023 20.6907 18.7376 20.3948 18.2236L18.2142 14.5167C17.9027 14.0027 17.747 13.7379 17.5601 13.6445C17.451 13.5909 17.3312 13.563 17.2096 13.563C17.0881 13.563 16.9682 13.5909 16.8592 13.6445C16.6567 13.7535 16.501 14.0183 16.1895 14.5634L14.0245 18.2703C13.713 18.8154 13.5573 19.0958 13.5728 19.3138C13.58 19.4345 13.6146 19.5519 13.6739 19.6572C13.7333 19.7624 13.8159 19.8528 13.9155 19.9213C14.2719 20.0141 14.6447 20.0248 15.0058 19.9524V19.9524Z"
          fill="white"
        ></path>
      </svg>
    </div>
  </Tooltip>
);

export const PolygonTokenIcon = ({ size }) => (
  <Tooltip label="Polygon" arrowSize={4} withArrow>
    <div>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        class="css-jklphm"
      >
        <circle cx="12" cy="12" r="12" fill="#8247E5"></circle>
        <path
          d="M16 9.32c-.28-.16-.64-.16-.96 0l-2.24 1.32-1.52.84-2.2 1.32c-.28.16-.64.16-.96 0L6.4 11.76a.975.975 0 01-.48-.84v-2c0-.32.16-.64.48-.84l1.72-1c.28-.16.64-.16.96 0l1.72 1.04c.28.16.48.48.48.84v1.32l1.52-.88V8.04c0-.32-.16-.64-.48-.84l-3.2-1.88c-.28-.16-.64-.16-.96 0L4.88 7.24a.88.88 0 00-.48.8v3.76c0 .32.16.64.48.84l3.24 1.88c.28.16.64.16.96 0l2.2-1.28 1.52-.88 2.2-1.28c.28-.16.64-.16.96 0l1.72 1c.28.16.48.48.48.84v2c0 .32-.16.64-.48.84l-1.68 1c-.28.16-.64.16-.96 0l-1.72-1a.975.975 0 01-.48-.84v-1.28l-1.52.88v1.32c0 .32.16.64.48.84l3.24 1.88c.28.16.64.16.96 0l3.24-1.88c.28-.16.48-.48.48-.84v-3.8c0-.32-.16-.64-.48-.84L16 9.32z"
          fill="#fff"
        ></path>
      </svg>
    </div>
  </Tooltip>
);

export const ArbitrumTokenIcon = ({ size }) => (
  <Tooltip label="Arbitrum" arrowSize={4} withArrow>
    <div>
      <svg width={size} height={size} fill="none" viewBox="0 0 24 24">
        <path
          fill="#2d374b"
          d="M14.705 10.996l1.762-2.99 4.75 7.4.003 1.42-.015-9.772a.736.736 0 00-.34-.587l-8.554-4.92a.754.754 0 00-.73.048l-.03.018-8.302 4.811-.033.016a.733.733 0 00-.43.625l.014 7.963 4.426-6.86c.556-.909 1.77-1.202 2.898-1.186l1.322.035-7.793 12.497.919.53L12.458 7.03l3.485-.013L8.078 20.36l3.278 1.886.392.224a.75.75 0 00.528.011l8.672-5.027-1.658.96-4.586-7.417zm.672 9.686l-3.31-5.196 2.02-3.43 4.348 6.854-3.058 1.773z"
        ></path>
        <path
          fill="#28a0f0"
          d="M12.065 15.487l3.311 5.195 3.058-1.772-4.347-6.853zm9.155 1.339l-.002-1.42-4.751-7.4-1.763 2.991 4.587 7.417 1.657-.96a.735.735 0 00.272-.535v-.093z"
        ></path>
        <path
          fill="#fff"
          d="M1.311 18.165l2.342 1.35 7.793-12.498-1.322-.035c-1.127-.016-2.34.277-2.898 1.187L2.8 15.028l-1.489 2.287zM15.943 7.017l-3.485.013L4.57 20.043l2.756 1.587.75-1.271 7.866-13.342z"
        ></path>
        <path
          fill="#96bedc"
          d="M22.689 7a2.22 2.22 0 00-1.042-1.786L12.981.231a2.254 2.254 0 00-1.988 0c-.072.036-8.427 4.881-8.427 4.881A2.204 2.204 0 001.31 6.994v10.32l1.49-2.287-.014-7.963a.734.734 0 01.307-.554c.039-.027 8.536-4.946 8.563-4.96a.754.754 0 01.654-.003l8.553 4.92c.202.129.33.347.34.586v9.865a.715.715 0 01-.255.534l-1.658.962-.856.496-3.059 1.772-3.1 1.797a.753.753 0 01-.529-.01l-3.67-2.11-.75 1.27 3.299 1.9.286.161c.123.07.207.115.237.13.234.114.571.18.875.18.278 0 .55-.051.808-.152l9.008-5.217a2.202 2.202 0 00.849-1.659z"
        ></path>
      </svg>
    </div>
  </Tooltip>
);
